module.exports = __webpack_public_path__ + "img/ARCH_08_prew.abdcd876.jpg";